import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Spinner } from "react-bootstrap";
import { formatDate } from "../../util/inputvalidations";
import { getNewsFeedById } from "../../api/network";
import { toastError } from "../Common/ToastAlert";
import { toast } from "react-toastify";

const PreviewNewsFeed = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getNewsFeedById(id);
        setData(response.data.result);
      } catch (error) {
        toast.error("Feed not found in API response", toastError());
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "80vh" }}
      >
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!data) {
    return (
      <div className="text-center mt-5">
        <h3>Feed not found</h3>
        <button className="dsm-btn-primary mt-3" onClick={() => navigate("/")}>
          Go Home
        </button>
      </div>
    );
  }

  const parseContent = (content) => {
    if (!content) return "";
    try {
      if (
        typeof content === "string" &&
        (content.startsWith('"') ||
          content.startsWith("{") ||
          content.startsWith("["))
      ) {
        return JSON.parse(content);
      }
      return content;
    } catch (e) {
      return content;
    }
  };

  return (
    <div className="right-container">
      <div className="inner-body-container">
        <div className="p-4 p-md-5 shadow-sm main-section">
          <div className="border-bottom pb-3 mb-4 text-center text-md-start">
            <h2 className="text-capitalize mb-3">{data?.title}</h2>
            <h3 className="text-capitalize mb-3">{data?.subtitle}</h3>

            <div className="d-flex align-items-center justify-content-center justify-content-md-start gap-3 flex-wrap">
              <span
                style={{ fontSize: "14px", color: "#666", fontWeight: "500" }}
              >
                {formatDate(data?.updatedAt || data?.createdAt, {
                  color: "#0076FC",
                })}
              </span>

              {data?.hashtag && (
                <span className="muted-badge">#{data.hashtag}</span>
              )}
            </div>
          </div>

          <Row>
            {data?.image && (
              <Col lg={12} className="mb-4 text-center">
                <img
                  src={data.image}
                  alt={data.title}
                  className="img-fluid"
                  style={{
                    maxHeight: "450px",
                    width: "100%",
                    objectFit: "cover",
                    borderRadius: "12px",
                  }}
                />
              </Col>
            )}
            <Col lg={12}>
              <div
                className="mt-2 preview-content ProseMirror"
                style={{
                  fontSize: "16px",
                  lineHeight: "1.8",
                  color: "#333",
                  textAlign: "left",
                }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: parseContent(data?.content),
                  }}
                />
              </div>
            </Col>
          </Row>
          <div className="d-flex justify-content-center justify-content-md-end mt-5 pt-4 border-top">
            <button
              type="button"
              className="dsm-btn-secondary"
              onClick={() => navigate(-1)}
              style={{ minWidth: "120px" }}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewNewsFeed;
